import type { EnemyConfig } from '../../entities/EnemyConfig';
import { MOUSE_CONFIG } from './Mouse';
import { RABBIT_CONFIG } from './Rabbit';
import { BEETLE_CONFIG } from './Beetle';
import { BOARLING_CONFIG } from './Boarling';
import { DEER_CONFIG } from './Deer';
import { KANGAROO_CONFIG } from './Kangaroo';
import { KANGAROO_JOEY_CONFIG } from './KangarooJoey';
import { FOX_CONFIG } from './Fox';
import { WOLF_CONFIG } from './Wolf';

export const ENEMY_CONFIGS: Record<string, EnemyConfig> = {
  mouse: MOUSE_CONFIG,
  rabbit: RABBIT_CONFIG,
  beetle: BEETLE_CONFIG,
  boarling: BOARLING_CONFIG,
  deer: DEER_CONFIG,
  kangaroo: KANGAROO_CONFIG,
  kangaroo_joey: KANGAROO_JOEY_CONFIG,
  fox: FOX_CONFIG,
  wolf: WOLF_CONFIG,
};

export function getEnemyConfig(id: string): EnemyConfig {
  const config = ENEMY_CONFIGS[id];
  if (!config) throw new Error(`Unknown enemy id: ${id}`);
  return config;
}
